/**
 * Helper para transferir datos de sesión entre aplicaciones mediante URL
 * Usa Base64 para codificar los datos de forma segura
 */

/**
 * Codifica los datos de sesión para transferirlos por URL
 * @param {object} dataUser - Datos del usuario
 * @param {object} dataToken - Datos del token
 * @param {object} dataClient - Datos del cliente
 * @param {string} token - Access token
 * @param {string} refreshToken - Refresh token
 * @param {string} languages - Lenguajes disponibles
 * @returns {string} Query string con los datos codificados
 */
export const encodeSessionData = (dataUser, dataToken, dataClient, token, refreshToken, languages) => {
  try {
    const sessionData = {
      dataUser: JSON.stringify(dataUser),
      dataToken: JSON.stringify(dataToken),
      dataClient: JSON.stringify(dataClient),
      token: token,
      refreshToken: refreshToken,
      languages: languages,
      timestamp: Date.now() // Para validar que no sea muy antiguo
    };
    
    // Codificar en Base64
    const encoded = btoa(JSON.stringify(sessionData));
    return `?session=${encodeURIComponent(encoded)}`;
  } catch (error) {
    console.error('Error encoding session data:', error);
    return '';
  }
};

/**
 * Decodifica los datos de sesión desde la URL
 * @param {string} sessionParam - Parámetro 'session' de la URL
 * @returns {object|null} Datos de sesión decodificados o null si hay error
 */
export const decodeSessionData = (sessionParam) => {
  try {
    if (!sessionParam) return null;
    
    // Decodificar desde Base64
    const decoded = atob(decodeURIComponent(sessionParam));
    const sessionData = JSON.parse(decoded);
    
    // Validar que no tenga más de 5 minutos de antigüedad
    const fiveMinutesAgo = Date.now() - (5 * 60 * 1000);
    if (sessionData.timestamp < fiveMinutesAgo) {
      console.warn('Session data expired');
      return null;
    }
    
    return sessionData;
  } catch (error) {
    console.error('Error decoding session data:', error);
    return null;
  }
};
